
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import getProp from '@f/get-prop'
import { getWarehouseMetadataById } from 'selectors'
import { warehouseSetupRetry, warehouseSetupEditCredentials } from 'actions'
import WarehouseSetupError from '../../components/warehouse-setup-error'

const WarehouseSetupErrorContainer = props => (
  <WarehouseSetupError
    error={props.error}
    logo={props.logo}
    name={props.name}
    shouldShowContactUs={props.shouldShowContactUs}
    onEditCredentials={props.onEditCredentials}
    onRetry={props.onEditCredentials} />
)

function mapStateToProps (state) {
  const { databaseId, error, failedConnectionAttempts } = state.application.warehouseSetup
  const database = getWarehouseMetadataById(state, databaseId)
  const logo = getProp('logos.default', database)
  const name = getProp('name', database)
  return { logo, name, error, shouldShowContactUs: failedConnectionAttempts > 1 }
}

function mapDispatchToProps (dispatch, ownProps) {
  return {
    onRetry: () => dispatch(warehouseSetupRetry(ownProps.workspaceSlug)),
    onEditCredentials: () => dispatch(warehouseSetupEditCredentials())
  }
}

WarehouseSetupErrorContainer.displayName = 'WarehouseSetupErrorContainer'

WarehouseSetupErrorContainer.propTypes = {
  error: PropTypes.object.isRequired,
  logo: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onEditCredentials: PropTypes.func.isRequired,
  shouldShowContactUs: PropTypes.bool.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(WarehouseSetupErrorContainer)



// WEBPACK FOOTER //
// ./pages/workspace-warehouses/containers/warehouse-setup-error/index.js